import { atom } from 'recoil'
import { useRecoilValue } from 'recoil'
import { defaultLanguage } from '../../i18n/i18n'

export const languageStore = atom({
    key: 'languageStore',
    default: {
        currentLanguage: defaultLanguage,
    },
})

const useLanguageStore = () => {
    const languageState = useRecoilValue(languageStore)
    return {
        ...languageState,
    }
}

export default useLanguageStore
